/**
 * Session-persistent shuffle seed for the catalog "Shuffle" sort. Generated
 * once per browser session and kept in sessionStorage, so the random order
 * stays stable while the user navigates / paginates, and reshuffles on a new
 * session. See docu/flows/analytics/engagement-trending-cart.md.
 */
const KEY = "catalogShuffleSeed";

export const getShuffleSeed = (): string => {
  try {
    let seed = sessionStorage.getItem(KEY);
    if (!seed) {
      seed = Math.random().toString(36).slice(2, 12);
      sessionStorage.setItem(KEY, seed);
    }
    return seed;
  } catch {
    // sessionStorage unavailable (private mode etc.) — fall back to a per-call
    // seed; ordering just won't persist across navigations.
    return "shuffle";
  }
};

/** Regenerate the seed (a "Shuffle again" action). */
export const reshuffleSeed = (): string => {
  const seed = Math.random().toString(36).slice(2, 12);
  try {
    sessionStorage.setItem(KEY, seed);
  } catch {
    /* ignore */
  }
  return seed;
};

/** Small deterministic string→int hash, for seeded client-side shuffling of
    smart-search results (the server handles the browse path via md5). */
export const seededHash = (str: string): number => {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
};
